import React, { useState, useEffect, Fragment } from 'react';
import {
    Grid,
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    TablePagination,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';

// Icons
import SearchIcon from '@material-ui/icons/Search';
import DownloadIcon from '@material-ui/icons/ArrowDownward';
import translation from "../../i18n/i18.json"
import useStyles from "./UserHistoryManagement.css"
import AllActions from '../../actions';
import { InforDisplyaDuration } from '../../constants/AppConstants';
import { MasterDataService } from '../../services/MasterDataService';
import { UserHistoryFilter } from '../../models/Master/UserHistoryFilter';
import { User } from '../../models/Master/User';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Company } from '../../models/Company';
import { VendorMasterData } from '../../services/VendorMasterData';
import { UserHistory, UserHistoryReport, UserHistoryResult } from '../../models/UserHistoryResult';
import { UserHistoryService } from '../../services/UserHistoryService';

const icon = <CheckBoxOutlineBlankIcon />;
const checkedIcon = <CheckBoxIcon />;
let pastWeekDay = new Date();
pastWeekDay.setDate(pastWeekDay.getDate() - 7);
let pastWeekDayText = pastWeekDay.toISOString().substring(0,10);

export default function UserHistoryManagement() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const INITIAL_FILTERS = {
        fromDate: pastWeekDayText,
        toDate: "",
        changedByIds: [],
        systemUserIds:[],
        companyCodes: [],
        timeZone: new Date().getTimezoneOffset()
    }

    const [filterParams, setFilterParams] = useState<UserHistoryFilter>(INITIAL_FILTERS);
    const [userHistoryTableCurrentPage, setUserHistoryTableCurrentPage] = React.useState(0);
    const [userHistoryTableRows, setUserHistoryTableRows] = useState<UserHistoryReport[]>([]);
    const [userHistoryTableRowCount, setUserHistoryTableRowCount] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [isTableLoading, setIsTableLoading] = React.useState(false);
    const [userList, setUserList] = useState(Array<User>());
    const [companyList, setCompanyList] = useState(Array<Company>());

    const userHistoryTableColumnData = [
        { name: 'Saved Date' },
        { name: 'Saved By' },
        { name: 'Created Date' },
        { name: 'Created By' },
        { name: 'Status' },
        { name: 'System User' },
        { name: 'Company/Cluster' },
        { name: 'Roles' },
        { name: 'RM Categories' },
        { name: 'Procurement Categories' }
    ]

    useEffect(() => {
        setUserHistoryTableCurrentPage(0)
        setFilterParams(INITIAL_FILTERS)
        setUserHistoryTableRows([])
        getUsers();
        getCompanies();
    }, [])

    useEffect(() => {
        if (isTableLoading) {
            //setUserHistoryTableCurrentPage(0);
            getHistoryData();
        }
    }, [isTableLoading])

    const prepareForRequest = () => {
        dispatch(AllActions.backDropActions.openBackDrop());
    };

    const compeleteRequest = (success: boolean, message?: string) => {
        dispatch(AllActions.backDropActions.closeBackDrop());
        if (message) {
            if (success) {
                dispatch(AllActions.infoActions.openInforSuccess(message, InforDisplyaDuration.common));
            } else {
                dispatch(AllActions.infoActions.openInforError(message, InforDisplyaDuration.common));
            }
        }
    };

    const getUsers = () => {
        return MasterDataService.getUsers(
          function (users: User[]) {
            setUserList(users);
          },
          function (error: Error) {
            setUserList([]);
          }
        );
    };

    const getCompanies = () => {
      VendorMasterData.getCompanyCodes(
        function (companies: Array<Company>) {
          setCompanyList(companies);
        },
        function (error: Error) {
            setCompanyList([]);
        }
      );
    };  

    const getFilter = () => {
        if(filterParams.fromDate){
            return {
                fromDate: filterParams.fromDate ? filterParams.fromDate : null,
                toDate: filterParams.toDate ? filterParams.toDate : null,
                companyCodes: filterParams.companyCodes,
                changedByIds: filterParams.changedByIds,
                systemUserIds: filterParams.systemUserIds,
                pageNo: userHistoryTableCurrentPage + 1,//zero based
                pageSize: rowsPerPage,
                timeZone: new Date().getTimezoneOffset()
            };

        }else{
            setIsTableLoading(false);
            dispatch(AllActions.infoActions.openInforError(translation.user_mangemnet_history_filter_fromdate_required, InforDisplyaDuration.common));
        }
    }

    const getHistoryData = () => {
        var filter = getFilter();
        if(filter){
            prepareForRequest();
            UserHistoryService.GetUserHistory(
                filter,
                function (data: UserHistoryResult) {
                    let userHistoryReports: UserHistoryReport[] = [];
                    //set cluster company count
                    if(data && data.userHistories){
                        data.userHistories.forEach(h =>  {
                            let userHistoryReport:UserHistoryReport = {
                                id: h.id,
                                savedBy: h.savedBy,
                                savedDate: h.savedDate,
                                createdDate: h.createdDate,
                                createdBy: h.createdBy,
                                userName: h.userName,
                                emailAddress: h.emailAddress,
                                status: h.status,
                                userCompaniesOrClusters: []
                            }
                            if(h.userClusters && h.userClusters.length > 0){
                                h.userClusters.forEach(c => {
                                    userHistoryReport.userCompaniesOrClusters!.push({
                                        comapanyCluster: c.clusterName,
                                        status: c.status,
                                        roles: ( c.roles && c.roles.length > 0 ) ? c.roles : [{ role: '', status: '' }],
                                        rmCategories:( c.rmCategories && c.rmCategories.length > 0 ) ? c.rmCategories : [{ rmCategory: '', status: '' }],
                                        procurementCategories:( c.procurementCategories && c.procurementCategories.length > 0 ) ? c.procurementCategories : [{ procurementCategory: '', status: '' }],
                                    });
                            })}
                            if(h.userCompanies && h.userCompanies.length > 0){
                                h.userCompanies.forEach(c => {
                                    userHistoryReport.userCompaniesOrClusters!.push({
                                        comapanyCluster: c.comapanyCode,
                                        status: c.status,
                                        roles: ( c.roles && c.roles.length > 0 ) ? c.roles : [{ role: '', status: '' }],
                                        rmCategories: ( c.rmCategories && c.rmCategories.length > 0 ) ? c.rmCategories : [{ rmCategory: '', status: '' }],
                                        procurementCategories: ( c.procurementCategories && c.procurementCategories.length > 0 ) ? c.procurementCategories : [{ procurementCategory: '', status: '' }]
                                    });
                            })}
                            if(userHistoryReport.userCompaniesOrClusters?.length == 0){
                                userHistoryReport.userCompaniesOrClusters!.push({
                                    comapanyCluster: '',
                                    status: '',
                                    roles: [{ role: '', status: '' }],
                                    rmCategories: [{ rmCategory: '', status: '' }],
                                    procurementCategories: [{ procurementCategory: '', status: '' }]
                                });
                            }
                            userHistoryReports.push(userHistoryReport);    
                        });
                    }
                    setUserHistoryTableRows(userHistoryReports);
                    setUserHistoryTableRowCount(data ? data.rowCount : 0);
                    compeleteRequest(true);
                    setIsTableLoading(false);
                },
                function (error: Error) {
                    setUserHistoryTableRows([]);
                    setUserHistoryTableRowCount(0);
                    compeleteRequest(false, translation.user_mangemnet_history_loading_error);
                    setIsTableLoading(false);
                }
            );
        }
    }

    const handleChange = (input: string) => (e: any) => {
        let val: any = e.target.value;
        setFilterParams({ ...filterParams!, [input]: val });
    }

    // handle pagination page change event
    const handleChangePage = (event: unknown, newPage: number) => {
        setUserHistoryTableCurrentPage(newPage);
        setIsTableLoading(true);
    };

    const handleRowsPerPageChange = (event: any) => {
        setRowsPerPage(event.target.value);
        setUserHistoryTableCurrentPage(0);
        setIsTableLoading(true);
    };

    const filterOptionsChangedBy = (options: User[], state: any) => {
        if(state.inputValue && state.inputValue.trim().length >= 3){
            return createFilterOptions({ stringify: (option : User) => option.emailAddress })(options, state);
        } 
        return [];
    };

    const filterOptionsCompanies = (options: Company[], state: any) => {
        //if(state.inputValue && state.inputValue.trim().length >= 3){
            return createFilterOptions({ stringify: (option : Company) => option.code })(options, state);
        //} 
        //return [];
    };
    
    const handleChangeAutoCompete = (e: any, input: string, newValue: any) => {
        if (input === "changedByIds" || input === "systemUserIds") {
            let userIds = newValue ? newValue.map( (u:User) =>  u.id) : [];
            setFilterParams({ ...filterParams!, [input]: userIds });
        } 
        else if (input === "companyCodes") {
            let companyCodes = newValue ? newValue.map( (u:Company) =>  u.code) : [];
            setFilterParams({ ...filterParams!, [input]: companyCodes });
        } 
    };

    const handleDownload = () => {
        var filter = getFilter();
        if(filter){
            filter.pageSize = 0;//load all
            prepareForRequest();
            UserHistoryService.downlodReport(
                filter,
                function (success: any) {
                compeleteRequest(true);
                },
                function (error: any) {
                compeleteRequest(false, translation.report_get_nodata);
                }
            );
        } 
      };

    const getStatusClass = (status: string) => {
        if(status.toUpperCase() == 'ADDED'){
            return classes.tblRowAddedStatus;
        } else if(status.toUpperCase() == 'DELETED'){
            return classes.tblRowRemoveStatus;
        } else if(status.toUpperCase() == 'CHANGED'){
            return classes.tblRowChangedStatus;
        }
        return '';
    }

    return (
        <React.Fragment>
              <Grid
          container
          spacing={2}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.createHeader}
        >
          <span className={classes.createHeaderTxt}>
          {translation.main_menu_user_mangemnet_history}
          </span>
          {/* <span className={classes.createHeaderLine}></span> */}
        </Grid>
            {/* Filters */}
            <Grid
                container
                spacing={2}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.filterheader}
            >
            {/* <Grid
                container
                spacing={2}
                item
                xs={12}
                sm={12}
                md={1}
                lg={1}
                className={classes.filterheader}
            >
                Filter
            </Grid> */}
            <Grid container spacing={2} item xs={12} sm={12} md={11} lg={11}>                
                <div className={classes.filterWrapper}> 
                    <div style={ {display: 'flex'}}>
                        <label className={classes.filterLbl}>
                        {translation.user_mangemnet_filter_changed_by}
                        </label>
                        <div className={classes.inputWrapperFilterFull}>
                        <Autocomplete
                            multiple
                            options={userList.map(
                                (obj: User, index: number) => obj
                            )}
                            getOptionLabel={(option) => option.emailAddress}
                            filterOptions={filterOptionsChangedBy}
                            onChange={(e, newValue) => {
                                e.preventDefault();
                                handleChangeAutoCompete(e, "changedByIds", newValue);
                            }}
                            // renderOption={(option, { selected }) => (
                            //     <React.Fragment>
                            //         <Checkbox
                            //         icon={icon}
                            //         checkedIcon={checkedIcon}
                            //         style={{ marginRight: 8 }}
                            //         checked={selected}
                            //         />
                            //         {option.emailAddress}
                            //     </React.Fragment>)}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                margin="normal"
                                variant="outlined"
                                inputProps={{
                                    ...params.inputProps,
                                }}
                                />
                            )}
                            />
                        </div>
                    </div>
                </div>
                <div className={classes.filterWrapper}> 
                    <div style={ {display: 'flex'}}>
                        <label className={classes.filterLbl}>
                        {translation.user_mangemnet_filter_system_user}
                        </label>
                        <div className={classes.inputWrapperFilterFull}>
                        <Autocomplete
                            multiple
                            options={userList.map(
                                (obj: User, index: number) => obj
                            )}
                            getOptionLabel={(option) => option.emailAddress}
                            filterOptions={filterOptionsChangedBy}
                            onChange={(e, newValue) => {
                                e.preventDefault();
                                handleChangeAutoCompete(e, "systemUserIds", newValue);
                            }}
                            // renderOption={(option, { selected }) => (
                            //     <React.Fragment>
                            //         <Checkbox
                            //         icon={icon}
                            //         checkedIcon={checkedIcon}
                            //         style={{ marginRight: 8 }}
                            //         checked={selected}
                            //         />
                            //         {option.emailAddress}
                            //     </React.Fragment>)}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                margin="normal"
                                variant="outlined"
                                inputProps={{
                                    ...params.inputProps,
                                }}
                                />
                            )}
                            />
                        </div>
                    </div>
                </div>
                <div className={classes.filterWrapper}> 
                    <div style={ {display: 'flex'}}>
                        <label className={classes.filterLbl}>
                        {translation.user_mangemnet_filter_companies}
                        </label>
                        <div className={classes.inputWrapperFilterFull}>
                        <Autocomplete
                            multiple
                            options={companyList.map(
                                (obj: Company, index: number) => obj
                            )}
                            getOptionLabel={(option) => option.code}
                            filterOptions={filterOptionsCompanies}
                            onChange={(e, newValue) => {
                                e.preventDefault();
                                handleChangeAutoCompete(e, "companyCodes", newValue);
                            }}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    {option.name}
                                </React.Fragment>)}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                margin="normal"
                                variant="outlined"
                                inputProps={{
                                    ...params.inputProps,
                                }}
                                />
                            )}
                            />
                        </div>
                    </div>
                </div>
                <div className={classes.filterWrapper}>
                    <div className={classes.dataBlock}>
                        <label className={classes.filterLbl}>
                        {translation.user_mangemnet_filter_startdate}
                        </label>
                        <div className={classes.inputWrapperFilter}>
                        <TextField
                            variant="outlined"
                            type="date"
                            onChange={handleChange("fromDate")}
                            defaultValue={pastWeekDay.toISOString().substring(0,10)}
                        ></TextField>
                        </div>
                    </div>
                    <div className={classes.dataBlock}>
                        <label className={classes.filterLbl}>
                        {translation.user_mangemnet_filter_enddate}
                        </label>
                        <div className={classes.inputWrapperFilter}>
                        <TextField
                            variant="outlined"
                            type="date"
                            onChange={handleChange("toDate")}
                            InputProps={{ inputProps: {min: filterParams.fromDate} }}
                        ></TextField>
                        </div>
                    </div>                    
                    <div className={classes.dataBlock}>
                        <div className={classes.searchBtnWrapper}>
                            <Button onClick={() => { setUserHistoryTableCurrentPage(0); setIsTableLoading(true); } } style={{ float: "left" }}>
                                <SearchIcon>
                                </SearchIcon>{translation.dashboard_filternm_btntxt}
                            </Button>
                        </div>
                        <div className={classes.greenBtnWrapper}>
                            <Button onClick={() => { handleDownload(); } } style={{ float: "left" }}>
                                <DownloadIcon>
                                </DownloadIcon>{translation.file_dwnld_btn_lbl}
                            </Button>
                        </div>
                    </div>
                </div>
            </Grid>
            </Grid>
            <div className={classes.tblOuterBG}>
                <TableContainer className={classes.tblContainer}>
                    <Table size="small" stickyHeader aria-label="sticky table">
                        <TableHead className={classes.tblHeader}>
                            <TableRow>
                                {
                                    userHistoryTableColumnData.map((column, index) => {
                                        return <TableCell style={{ minWidth: "200px" }}>{column.name}</TableCell>;
                                    })
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody className={classes.tblBody}>
                            {
                                userHistoryTableRows.map((row, index) => {
                                    return (
                                        <Fragment>
                                            <TableRow key={index}>
                                                <TableCell rowSpan={ row.userCompaniesOrClusters && row.userCompaniesOrClusters.length > 0 ? row.userCompaniesOrClusters.length : 1 }>
                                                    {row.savedDate}
                                                </TableCell>
                                                <TableCell rowSpan={ row.userCompaniesOrClusters && row.userCompaniesOrClusters.length > 0 ? row.userCompaniesOrClusters.length : 1 }>
                                                    {row.savedBy}
                                                </TableCell>
                                                <TableCell rowSpan={ row.userCompaniesOrClusters && row.userCompaniesOrClusters.length > 0 ? row.userCompaniesOrClusters.length : 1 }>
                                                    {row.createdDate}
                                                </TableCell>
                                                <TableCell rowSpan={ row.userCompaniesOrClusters && row.userCompaniesOrClusters.length > 0 ? row.userCompaniesOrClusters.length : 1 }>
                                                    {row.createdBy}
                                                </TableCell>
                                                <TableCell rowSpan={ row.userCompaniesOrClusters && row.userCompaniesOrClusters.length > 0 ? row.userCompaniesOrClusters.length : 1 }>
                                                    <span className={getStatusClass(row.status)}>{row.status}</span>
                                                </TableCell>
                                                <TableCell rowSpan={ row.userCompaniesOrClusters && row.userCompaniesOrClusters.length > 0 ? row.userCompaniesOrClusters.length : 1 }>
                                                    {row.emailAddress}
                                                </TableCell>
                                                <TableCell>{ row.userCompaniesOrClusters![0].comapanyCluster &&
                                                    (<span className={getStatusClass(row.userCompaniesOrClusters![0].status)}>{row.userCompaniesOrClusters![0].comapanyCluster + '-' + row.userCompaniesOrClusters![0].status}</span>)
                                                }</TableCell>
                                                <TableCell>{row.userCompaniesOrClusters![0].roles?.map(r => r.role && (
                                                        <span className={getStatusClass(r.status)}>{r.status + '-' +  r.role}</span>
                                                    ))}
                                                </TableCell>
                                                <TableCell>{row.userCompaniesOrClusters![0].rmCategories?.map(r => r.rmCategory && (
                                                        <span className={getStatusClass(r.status)}>{r.status + '-' +  r.rmCategory}</span>
                                                    ))}
                                                </TableCell>
                                                 <TableCell>{row.userCompaniesOrClusters![0].procurementCategories?.map(r => r.procurementCategory && (
                                                        <span className={getStatusClass(r.status)}>{r.status + '-' +  r.procurementCategory}</span>
                                                    ))}
                                                </TableCell>
                                            </TableRow>
                                            {row.userCompaniesOrClusters 
                                                && row.userCompaniesOrClusters.length > 1 
                                                && row.userCompaniesOrClusters.map((c, index) => (
                                                    (index > 0) && (
                                                <TableRow>
                                                    <TableCell>{c.comapanyCluster && ( <span className={getStatusClass(c.status)}>{c.comapanyCluster + '-' + c.status}</span>)}</TableCell>
                                                    <TableCell>{c.roles?.map(r => r.role && (
                                                            <span className={getStatusClass(r.status)}>{r.status + '-' +  r.role}</span>
                                                        ))}
                                                    </TableCell>
                                                    <TableCell>{c.rmCategories?.map(r => r.rmCategory && (
                                                            <span className={getStatusClass(r.status)}>{r.status + '-' +  r.rmCategory}</span>
                                                        ))}
                                                    </TableCell>
                                                     <TableCell>{c.procurementCategories?.map(r => r.procurementCategory && (
                                                            <span className={getStatusClass(r.status)}>{r.status + '-' +  r.procurementCategory}</span>
                                                        ))}
                                                    </TableCell>
                                                </TableRow>)
                                                ))
                                            } 
                                        </Fragment>
                                    )
                                }
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10,20,40]}
                    component="div"
                    count={userHistoryTableRowCount}
                    rowsPerPage={rowsPerPage}
                    page={userHistoryTableCurrentPage}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />
            </div>
        </React.Fragment>
    )
}